(function() {
	'use strict';

	angular
	.module('hub', [
		'ngSanitize', 'ngAnimate', 'angularMoment', 'restangular', 'hljs',
		'ui.router', 'ui.bootstrap', 'ui.select',
		'toastr', 'angular-loading-bar', 'evalua.angular', 'caMenu', 'caLoadingOverlay', 'chart.js',
		'hubApi', 'hubAuth', 'hubChannelSettings', 'hubChannelTypes', 'hubCompanies', 'hubCustomers',
		'hubDeliveries', 'hubUserSettings'
	])
	.filter('hbBytes', HbBytesFilter);

	// as seen in https://gist.github.com/thomseddon/3511330
	function HbBytesFilter() {
		return function(bytes, precision) {
			if (isNaN(parseFloat(bytes)) || !isFinite(bytes)){
				return '-';
			}
			if (typeof precision === 'undefined') {
				precision = 1;
			}
			var units = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'],
				number = Math.floor(Math.log(bytes) / Math.log(1024));
			return (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) +  ' ' + units[number];
		};
	}
})();

(function() {
  'use strict';

  angular
    .module('hub')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;

      vm.$onInit = function () {
        vm.relativeDate = moment(vm.creationDate).fromNow();
      };
    }
  }

})();

(function() {
	'use strict';

	angular
		.module('hub')
		.directive('hbDeliveryStatusLabel', HbDeliveryStatusLabel);

	/** @ngInject */
	function HbDeliveryStatusLabel(hbConstants) {
		var directive = {
			bindToController: true,
			controller: HbDeliveryStatusLabelController,
			controllerAs: 'vm',
			link: link,
			restrict: 'E',
			scope: {
				status: '='
			},
			templateUrl: 'app/components/delivery-status-label/delivery-status-label.html'
		};
		return directive;

		function link(scope, element, attrs) {
		}
	}

	/** @ngInject */
	function HbDeliveryStatusLabelController(hbConstants) {
		var vm = this;

		vm.getLabelClass = getLabelClass;
		vm.getStatusName = getStatusName;

		activate();

		function activate() {
		}

		function getLabelClass() {
			switch (vm.status) {
				case hbConstants.get().DELIVERY_STATUS.QUEUED.id:
				default:
					return 'default';
				case hbConstants.get().DELIVERY_STATUS.IN_PROGRESS.id:
					return 'info';
				case hbConstants.get().DELIVERY_STATUS.DELIVERED.id:
					return 'success';
				case hbConstants.get().DELIVERY_STATUS.FAILED.id:
					return 'danger';
				case hbConstants.get().DELIVERY_STATUS.CANCELED.id:
					return 'warning';
			}
		}

		function getStatusName() {
			return hbConstants.byId('DELIVERY_STATUS', vm.status).name;
		}
	}
})();

(function() {
	'use strict';

	angular
		.module('hub')
		.directive('hbChannelStatusIcon', HbChannelStatusIcon);

	/** @ngInject */
	function HbChannelStatusIcon(hbConstants) {
		var directive = {
			bindToController: true,
			controller: HbChannelStatusIconController,
			controllerAs: 'vm',
			link: link,
			restrict: 'E',
			scope: {
				status: '='
			},
			templateUrl: 'app/components/channel-status-icon/channel-status-icon.html'
		};
		return directive;

		function link(scope, element, attrs) {
		}
	}

	/** @ngInject */
	function HbChannelStatusIconController(hbConstants) {
		var vm = this;

		vm.getTextClass = getTextClass;
		vm.getStatusName = getStatusName;

		activate();

		function activate() {
		}

		function getTextClass() {
			switch (vm.status) {
				case hbConstants.get().CHANNEL_STATUS.ONLINE.id:
					return 'success';
				case hbConstants.get().CHANNEL_STATUS.OFFLINE.id:
					return 'danger';
				default:
					return 'default';
			}
		}

		function getStatusName() {
			return hbConstants.byId('CHANNEL_STATUS', vm.status).name;
		}
	}
})();

(function() {
	'use strict';

	angular
	.module('hubUserSettings', []);
})();

(function() {
	angular
	.module('hubUserSettings')
	.run(runBlock);

	/** @ngInject */
	function runBlock(caMenuService) {
		caMenuService.add({
			route: 'root.main.userSettings',
			text: 'Configuración',
			icon: 'cog'
		});
	}
})();

(function() {
	'use strict';

	angular
	.module('hubUserSettings')
	.config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider, $urlRouterProvider) {
		$stateProvider
		.state('root.main.userSettings', {
			url: '/user-settings',
			templateUrl: 'app/user-settings/user-settings.html',
			controller: 'UserSettingsController',
			controllerAs: 'vm',
			resolve: {
				/** @ngInject */
				settings: function($stateParams, UserSettings) {
					return UserSettings.getList();
				}
			}
		});
	}

})();

(function() {
	'use strict';

	angular
	.module('hubCustomers', []);
})();

(function() {
	'use strict';

	angular
	.module('hubCustomers')
	.controller('UserSettingsController', UserSettingsController);

	/** @ngInject */
	function UserSettingsController(hbConstants, settings) {
		var vm = this;
		vm.settings = null;
		vm.ui = {
			savingSettings: false
		};

		vm.saveSettings = saveSettings;

		activate();

		function activate() {
			if (settings.length > 0) {
				vm.settings = settings[0];
			}
		}

		function saveSettings() {
			if (vm.settings !== null) {
				vm.ui.savingSettings = true;
				vm.settings.save()
					.finally(function() {
						vm.ui.savingSettings = false;
					});
			}
		}
	}
})();

(function() {
	'use strict';

	angular
	.module('hub')
	.controller('MainController', MainController);

	/** @ngInject */
	function MainController($state, toastr, AuthManager, hbSession) {
		var vm = this;
		vm.hbSession = hbSession;

		vm.logout = logout;

		activate();

		function activate() {
		}

		function logout() {
			AuthManager.logout()
			.then(function() {
				toastr.success('Has cerrado tu sesión con éxito');
				$state.go('root.login');
			});
		}
	}
})();

(function() {
	'use strict';

	angular
	.module('hubDeliveries', ['naif.base64']);
})();

(function() {
	'use strict';

	angular
	.module('hubDeliveries')
	.controller('DeliveryDetailController', DeliveryDetailController)
	.controller('RepeatDeliveryConfirmationModalController', RepeatDeliveryConfirmationModalController);

	/** @ngInject */
	function DeliveryDetailController(hbConstants, delivery, hbDeliveryUtils) {
		var vm = this;
		vm.delivery = delivery;

		vm.canCancelDelivery = canCancelDelivery;
		vm.cancelDelivery = cancelDelivery;
		vm.canRepeatDelivery = canRepeatDelivery;
		vm.getErrorReasonLabelClass = getErrorReasonLabelClass;
		vm.getMetadataAsString = getMetadataAsString;
		vm.getSettingOverridesAsString = getSettingOverridesAsString;
		vm.repeatDelivery = repeatDelivery;
		vm.shouldDisplayErrorReason = shouldDisplayErrorReason;

		activate();

		function activate() {
		}

		/**
		 * Returns whether the current delivery can
		 * be repeated.
		 *
		 * @return {Boolean}
		 */
		function canRepeatDelivery() {
			return hbDeliveryUtils.canRepeat(delivery);
		}

		/**
		 * Puts this delivery back in the queue.
		 *
		 * @return {Promise}
		 */
		function repeatDelivery() {
			return hbDeliveryUtils.repeat(vm.delivery);
		}

		/**
		 * Returns whether the current delivery can
		 * be canceled.
		 *
		 * @return {Boolean}
		 */
		function canCancelDelivery() {
			return hbDeliveryUtils.canCanceled(delivery);
		}

		/**
		 * Cancels the current delivery.
		 *
		 * @return {Promise}
		 */
		function cancelDelivery() {
			hbDeliveryUtils.canceled(vm.delivery);
		}

		function getMetadataAsString() {
			return JSON.stringify(delivery.metadata, null, 4);
		}

		function getSettingOverridesAsString() {
			return JSON.stringify(delivery.setting_overrides, null, 4);
		}

		function shouldDisplayErrorReason(attempt) {
			return attempt.attempt_result_id !== hbConstants.get().ATTEMPT_RESULT.SUCCESS.id;
		}

		function getErrorReasonLabelClass(attempt) {
			var classes = {};
			classes[hbConstants.get().ATTEMPT_RESULT.TERMINAL_ERROR.id] = 'label-danger';
			classes[hbConstants.get().ATTEMPT_RESULT.RETRIABLE_ERROR.id] = 'label-warning';
			return classes[attempt.attempt_result_id];
		}
	}

	/** @ngInject */
	function RepeatDeliveryConfirmationModalController($scope, $uibModalInstance) {
		$scope.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		};

		$scope.ok = function () {
			$uibModalInstance.close();
		};
	}
})();

(function() {
	angular
	.module('hubDeliveries')
	.run(runBlock);

	/** @ngInject */
	function runBlock(caMenuService) {
		caMenuService.add({
			route: 'root.main.deliveries',
			text: 'Envíos',
			icon: 'rss',
			order: 2
		});
	}
})();

(function() {
	'use strict';

	angular
	.module('hubDeliveries')
	.config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider, $urlRouterProvider) {
		$stateProvider
		.state('root.main.deliveries', {
			url: '/deliveries',
			templateUrl: 'app/deliveries/deliveries.html',
			controller: 'DeliveriesController',
			controllerAs: 'vm',
			resolve: {
				/* @ngInject */
				deliveries: function(Deliveries) {
					return Deliveries.getList();
				}
			}
		})
		.state('root.main.deliveries.create', {
			url: '/create',
			templateUrl: 'app/deliveries/create-delivery.html',
			controller: 'CreateDeliveryController',
			controllerAs: 'vm'
		})
		.state('root.main.deliveries.detail', {
			url: '/{deliveryId}',
			templateUrl: 'app/deliveries/delivery-detail.html',
			controller: 'DeliveryDetailController',
			controllerAs: 'vm',
			resolve: {
				/* @ngInject */
				delivery: function($stateParams, Deliveries) {
					return Deliveries.one($stateParams.deliveryId)
						.get({with: 'attachments,attempts.channel.type,attempts.result,company,status,type'});
				}
			}
		});
	}

})();

(function() {
	'use strict';

	angular
	.module('hubDeliveries')
	.controller('DeliveriesController', DeliveriesController);

	/* @ngInject */
	function DeliveriesController(hbConstants, Deliveries, deliveries, hbDeliveryUtils) {
		var vm = this;

		vm.page = 1;
		vm.deliveries = deliveries;
		vm.hbConstants = hbConstants;
		vm.searchForm = {
			claimNumber: null
		};

		vm.filter = {
			field: null,
			value: null
		};

		vm.ui = {
			gettingDeliveries: false
		};

		vm.selectedStatus = [];

		vm.cancelDelivery = cancelDelivery;
		vm.clearSearch = clearSearch;
		vm.getDeliveries = getDeliveries;
		vm.getDeliveryStatusBadgeClass = getDeliveryStatusBadgeClass;
		vm.search = search;
		vm.canCancelDelivery = canCancelDelivery;
		vm.canRepeatDelivery = canRepeatDelivery;
		vm.repeatDelivery = repeatDelivery;
		vm.filterByClaimNumber = filterByClaimNumber;
		vm.getDeliveryStatus = getDeliveryStatus;
		vm.filterByStatus = filterByStatus;
		vm.previous = previous;
		vm.next = next;

		/**
		 * Clears the search form.
		 */
		function clearSearch()
		{
			clearFilterParameters();

			vm.searchForm.claimNumber = null;
			clearStatusSelect();

			vm.page = 1;
			getDeliveries();
		}

		function clearStatusSelect() {
			vm.selectedStatus = [];
		}

		/**
		 * Fetches deliveries from the API.
		 */
		function getDeliveries()
		{
			var params = {
				page: vm.page
			};

			if (vm.filter.field) {
				params[vm.filter.field] = vm.filter.value;
			}

			vm.ui.gettingDeliveries = true;

			Deliveries.getList(params)
				.then(function (deliveries) {
					vm.deliveries = deliveries;
				})
				.finally(function () {
					vm.ui.gettingDeliveries = false;
				});
		}

		function getDeliveryStatusBadgeClass(statusId) {
			switch (statusId) {
				case hbConstants.get().DELIVERY_STATUS.QUEUED.id:
				default:
					return 'label-default';
				case hbConstants.get().DELIVERY_STATUS.IN_PROGRESS.id:
					return 'label-info';
				case hbConstants.get().DELIVERY_STATUS.DELIVERED.id:
					return 'label-success';
				case hbConstants.get().DELIVERY_STATUS.FAILED.id:
					return 'label-danger';
				case hbConstants.get().DELIVERY_STATUS.CANCELED.id:
					return 'label-warning';
			}
		}

		/**
		 * Performs a delivery search by claim number.
		 */
		function search()
		{
			vm.filter.field = 'claim_number';
			vm.filter.value = vm.searchForm.claimNumber;

			clearStatusSelect();

			vm.page = 1;
			getDeliveries();
		}

		/**
		 * Returns whether the current delivery can
		 * be repeated.
		 *
		 * @param {Object} delivery
		 * @return {Boolean}
		 */
		function canRepeatDelivery(delivery) {
			return hbDeliveryUtils.canRepeat(delivery);
		}

		/**
		 * Puts this delivery back in the queue.
		 *
		 * @param {Object} delivery
		 * @return {Promise}
		 */
		function repeatDelivery(delivery) {
			return hbDeliveryUtils.repeat(delivery);
		}

		/**
		 * Returns whether the current delivery can
		 * be canceled.
		 *
		 * @param {Object} delivery
		 * @return {Boolean}
		 */
		function canCancelDelivery(delivery) {
			return hbDeliveryUtils.canCanceled(delivery);
		}

		/**
		 * Cancels the current delivery.
		 *
		 * @param {Object} delivery
		 * @return {Promise}
		 */
		function cancelDelivery(delivery) {
			return hbDeliveryUtils.canceled(delivery);
		}

		/**
		 * Performs a delivery search by claim number.
		 *
		 * @param {string} claimNumber
		 */
		function filterByClaimNumber(claimNumber)
		{
			clearStatusSelect();

			vm.filter.field = 'claim_number';
			vm.filter.value = claimNumber;
			vm.searchForm.claimNumber = vm.filter.value;

			vm.page = 1;
			getDeliveries();
		}

		/**
		 * Return delivery status objects list.
		 *
		 * @return {Array}
		 */
		function getDeliveryStatus() {
			var statusList = [];
			angular.forEach(hbConstants.get().DELIVERY_STATUS, function(status) {
				statusList.push(status);
			});
			return statusList;
		}

		/**
		 * Performs a delivery filter by status id.
		 */
		function filterByStatus()
		{
			clearFilterParameters();

			if (vm.selectedStatus.length > 0) {
				angular.forEach(vm.selectedStatus, function(status) {
					vm.filter.value = (vm.filter.value && (vm.filter.value + ',')) + status.id;
				});

				vm.filter.field = 'delivery_status_id';
			}

			vm.page = 1;
			getDeliveries();
		}

		/**
		 * Clear filter params
		 *
		 */
		function clearFilterParameters() {
			vm.filter.value = null;
			vm.filter.field = null;
		}

		/**
		 * Go to the previous page.
		 */
		function previous()
		{
			if (vm.page <= 1) {
				return;
			}

			vm.page -= 1;
			getDeliveries();
		}

		/**
		 * Go to the next page.
		 */
		function next()
		{
			vm.page += 1;
			getDeliveries();
		}
	}
})();

(function() {
	'use strict';

	angular
	.module('hubDeliveries')
	.controller('CreateDeliveryController', CreateDeliveryController);

	/** @ngInject */
	function CreateDeliveryController($state, toastr, hbConstants, Deliveries) {
		var vm = this;
		vm.hbConstants = hbConstants;
		vm.newDelivery = {
			company_id: null,
			delivery_type_id: null,
			claim_number: null,
			policy_number: null,
			metadata: null,
			setting_overrides: null,
			attachments: []
		};
		vm.selectedFiles = [];
		vm.ui = {
			creatingDelivery: false
		};

		vm.createDelivery = createDelivery;
		vm.getSelectedFiles = getSelectedFiles;

		activate();

		function activate() {
		}

		function createDelivery() {
			vm.ui.creatingDelivery = true;
			vm.newDelivery.attachments = _.map(vm.selectedFiles, function (f) {
				return {filename: f.filename, content: f.base64};
			});
			Deliveries.post(vm.newDelivery)
				.then(function(delivery) {
					toastr.success('Envío creado con éxito.');
					$state.go('root.main.deliveries.detail', {deliveryId: delivery.id});
				})
				.finally(function() {
					vm.ui.creatingDelivery = false;
				});
		}

		/**
		 * Returns a string representation of the
		 * selected files.
		 *
		 * @return {String}
		 */
		function getSelectedFiles() {
			return _(vm.selectedFiles)
				.map('filename')
				.join(', ');
		}
	}
})();

(function() {
	angular
	.module('hubCustomers')
	.run(runBlock);

	/** @ngInject */
	function runBlock(caMenuService) {
		caMenuService.add({
			route: 'root.main.customers',
			text: 'Clientes',
			icon: 'users'
		}, 'admin');
	}
})();

(function() {
	'use strict';

	angular
	.module('hubCustomers')
	.config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider, $urlRouterProvider) {
		$stateProvider
		.state('root.main.customers', {
			url: '/customers',
			templateUrl: 'app/customers/customers.html',
			controller: 'CustomersController',
			controllerAs: 'vm'
		})
		.state('root.main.customers.detail', {
			url: '/{customerId}',
			templateUrl: 'app/customers/customer-detail.html',
			controller: 'CustomerDetailController',
			controllerAs: 'vm',
			resolve: {
				/** @ngInject */
				customer: function($stateParams, Users) {
					return Users.one($stateParams.customerId).get({with: 'companies'});
				}
			}
		});
	}

})();

(function() {
	'use strict';

	angular
	.module('hubCustomers')
	.controller('CustomersController', CustomersController);

	/** @ngInject */
	function CustomersController(hbConstants, Users) {
		var vm = this;
		vm.customers = [];

		vm.getCustomers = getCustomers;

		activate();

		function activate() {
			vm.getCustomers();
		}

		function getCustomers() {
			Users.getList({role_id: hbConstants.get().ROLE.USER.id, with: 'companies'})
				.then(function(customers) {
					vm.customers = customers;
				});
		}
	}
})();

(function() {
	'use strict';

	angular
	.module('hubCustomers')
	.controller('CustomerDetailController', CustomerDetailController);

	/** @ngInject */
	function CustomerDetailController(hbConstants, Users, customer) {
		var vm = this;
		vm.companies = {};
		vm.customer = customer;
		vm.hbConstants = hbConstants;
		vm.newCompanyId = null;
		vm.ui = {
			savingCompanies: false
		};

		vm.saveCompanies = saveCompanies;

		activate();

		function activate() {
			var allIds = _.map(hbConstants.get().COMPANY, 'id');
			var currentIds = _.map(customer.companies, 'id');

			_.each(_.intersection(allIds, currentIds), function(val) {
				vm.companies[val] = true;
			});
			_.each(_.difference(allIds, currentIds), function(val) {
				vm.companies[val] = false;
			});
		}

		function saveCompanies() {
			var ids = _.filter(_.keys(vm.companies), function(val) {
				return vm.companies[val] === true;
			});

			vm.ui.savingCompanies = true;
			vm.customer.company_ids = ids;
			vm.customer.save({with: 'companies'})
				.then(function(customer) {
					vm.customer = customer;
				})
				.finally(function() {
					vm.ui.savingCompanies = false;
				});
		}
	}
})();

(function() {
	'use strict';

	angular
	.module('hub')
	.controller('DashboardController', DashboardController);

	/** @ngInject */
	function DashboardController($http, hbConfig) {
		var vm = this;
		vm.stats = {};

		vm.getStats = getStats;

		activate();

		function activate() {
			intializeStats();
			getStats();
		}

		/**
		 * Retrieves stats from the server and
		 * populates chart data.
		 *
		 * @return {Promise}
		 */
		function getStats() {
			return $http({
				method: 'GET',
				url: hbConfig.apiEndpoint + '/stats'
			}).then(function(res) {
				vm.stats.breakdown.data = [];
				vm.stats.breakdown.labels = _.map(res.data.delivered, 'x');
				vm.stats.breakdown.data.push(_.map(res.data.delivered, 'y'));
				vm.stats.breakdown.data.push(_.map(res.data.failed, 'y'));

				vm.stats.deliveredToday = _.last(res.data.delivered).y;
				vm.stats.failedToday = _.last(res.data.failed).y;
			});
		}

		/**
		 * Initializes the stats data structure.
		 */
		function intializeStats() {
			vm.stats = {
				deliveredToday: null,
				failedToday: null,
				breakdown: {
					colors: ['#5cb85c', '#d9534f'],
					data: null,
					labels: [],
					series: ['Entregados', 'Fallidos']
				}
			};
		}
	}
})();

(function() {
	'use strict';

	angular
	.module('hubCompanies', []);
})();

(function() {
	'use strict';

	angular
	.module('hubCompanies')
	.controller('CompanyDetailController', CompanyDetailController);

	/** @ngInject */
	function CompanyDetailController($q, Restangular, toastr, hbConstants, Channels, Companies, company) {
		var vm = this;
		vm.channelDeliveryTypes = {};
		vm.company = company;
		vm.hbConstants = hbConstants;
		vm.newChannel = {
			channel_type_id: null,
			company_id: company.id
		};
		vm.ui = {
			addingChannel: false,
			savingDeliveryTypes: false
		};

		vm.addChannel = addChannel;
		vm.getUnusedChannelTypes = getUnusedChannelTypes;
		vm.removeChannel = removeChannel;
		vm.saveChannelDeliveryTypes = saveChannelDeliveryTypes;

		activate();

		function activate() {
			var allIds = _.map(hbConstants.get().DELIVERY_TYPE, 'id');

			// TODO: refactor this, i'm pretty sure
			// there's a more elegant, efficient way
			// of accomplishing this
			_.each(company.channels, function(channel) {
				_.each(hbConstants.get().DELIVERY_TYPE, function(deliveryType) {
					if (! vm.channelDeliveryTypes[channel.id]) {
						vm.channelDeliveryTypes[channel.id] = {};
					}
					vm.channelDeliveryTypes[channel.id][deliveryType.id] = false;
				});
				_.each(channel.delivery_types, function(deliveryType) {
					vm.channelDeliveryTypes[channel.id][deliveryType.id] = true;
				});
			});
		}

		function addChannel() {
			vm.ui.addingChannel = true;
			Channels.post(vm.newChannel, {with: 'type'})
				.then(function(channel) {
					vm.company.channels.push(channel);
					toastr.success('Canal añadido con éxito.');
				})
				.finally(function() {
					vm.ui.addingChannel = false;
				});
		}

		function getUnusedChannelTypes() {
			var allIds = _.map(hbConstants.get().CHANNEL_TYPE, 'id');
			var usedIds = _.map(vm.company.channels, 'channel_type_id');
			var availableIds = _.difference(allIds, usedIds);
			return _.filter(hbConstants.get().CHANNEL_TYPE, function(val) {
				return availableIds.indexOf(val.id) >= 0;
			});
		}

		function removeChannel(channel) {
			_.remove(vm.company.channels, function(val) {
				return val.id === channel.id;
			});
			Restangular.one('channels', channel.id)
				.remove()
				.then(function() {
					toastr.success('Canal eliminado con éxito.');
				}, function() {
					vm.company.channels.push(channel);
				});
		}

		function saveChannelDeliveryTypes() {
			var promises = [];
			vm.ui.savingChannelDeliveryTypes = true;

			_.each(vm.company.channels, function(channel) {
				var deliveryTypeIds = _.filter(_.keys(vm.channelDeliveryTypes[channel.id]), function(val) {
					return vm.channelDeliveryTypes[channel.id][val] === true;
				});
				// TODO: refactor this, don't like the way
				// I used Restangular here
				channel = Restangular.restangularizeElement(null, channel, 'channels');
				channel.delivery_type_ids = deliveryTypeIds;
				promises.push(channel.put({with: 'delivery_types,type'}));
			});

			$q.all(promises)
				.then(function() {
					toastr.success('Tipos de envío guardados con éxito.');
				})
				.finally(function() {
					vm.ui.savingChannelDeliveryTypes = false;
				});
		}
	}
})();

(function() {
	angular
	.module('hubCompanies')
	.run(runBlock);

	/** @ngInject */
	function runBlock(caMenuService) {
		caMenuService.add({
			route: 'root.main.companies',
			text: 'Compañías',
			icon: 'suitcase'
		}, 'admin');
	}
})();

(function() {
	'use strict';

	angular
	.module('hubCompanies')
	.config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider, $urlRouterProvider) {
		$stateProvider
		.state('root.main.companies', {
			url: '/companies',
			templateUrl: 'app/companies/companies.html',
			controller: 'CompaniesController',
			controllerAs: 'vm'
		})
		.state('root.main.companies.detail', {
			url: '/{companyId}',
			templateUrl: 'app/companies/company-detail.html',
			controller: 'CompanyDetailController',
			controllerAs: 'vm',
			resolve: {
				/** @ngInject */
				company: function($stateParams, Companies) {
					return Companies.one($stateParams.companyId).get({with: 'channels.delivery_types,channels.type'});
				}
			}
		});
	}

})();

(function() {
	'use strict';

	angular
	.module('hubCompanies')
	.controller('CompaniesController', CompaniesController);

	/** @ngInject */
	function CompaniesController(Companies) {
		var vm = this;
		vm.companies = [];

		vm.getCompanies = getCompanies;

		activate();

		function activate() {
			vm.getCompanies();
		}

		function getCompanies() {
			Companies.getList({with: 'channels,channels.type'})
				.then(function(companies) {
					vm.companies = companies;
				});
		}
	}
})();

(function() {
	'use strict';

	angular
	.module('hubChannelTypes', []);
})();
(function() {
	angular
	.module('hubChannelTypes')
	.run(runBlock);

	/** @ngInject */
	function runBlock(caMenuService) {
		caMenuService.add({
			route: 'root.main.channelTypes',
			text: 'Tipos de canal',
			icon: 'commenting'
		}, 'admin');
	}
})();

(function() {
	'use strict';

	angular
	.module('hubChannelTypes')
	.config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider, $urlRouterProvider) {
		$stateProvider
		.state('root.main.channelTypes', {
			url: '/channel_types',
			templateUrl: 'app/channel-types/channel-types.html',
			controller: 'ChannelTypesController',
			controllerAs: 'vm'
		})
		.state('root.main.channelTypes.detail', {
			url: '/{channelTypeId}',
			templateUrl: 'app/channel-types/channel-type-detail.html',
			controller: 'ChannelTypeDetailController',
			controllerAs: 'vm',
			resolve: {
				/** @ngInject */
				channelType: function($stateParams, ChannelTypes) {
					return ChannelTypes.one($stateParams.channelTypeId).get({with: 'attributes'});
				}
			}
		});
	}

})();

(function() {
	'use strict';

	angular
	.module('hubChannelTypes')
	.controller('ChannelTypesController', ChannelTypesController);

	/** @ngInject */
	function ChannelTypesController(hbConstants) {
		var vm = this;
		vm.hbConstants = hbConstants;

		activate();

		////////////////

		function activate() {
		}
	}
})();

(function() {
	'use strict';

	angular
	.module('hubChannelTypes')
	.controller('ChannelTypeDetailController', ChannelTypeDetailController);

	/** @ngInject */
	function ChannelTypeDetailController(Restangular, toastr, ChannelTypeAttributes, channelType) {
		var vm = this;
		vm.channelType = channelType;
		vm.newAttribute = {};
		vm.ui = {
			addingAttribute: false
		};

		vm.addAttribute = addAttribute;
		vm.removeAttribute = removeAttribute;

		activate();

		////////////////

		function activate() {
			resetNewAttributeForm();
		}

		function addAttribute() {
			vm.ui.addingAttribute = true;
			ChannelTypeAttributes.post(vm.newAttribute)
				.then(function(attribute) {
					resetNewAttributeForm();
					vm.channelType.attributes.push(attribute);
					toastr.success('Atributo añadido con éxito.');
				})
				.finally(function() {
					vm.ui.addingAttribute = false;
				});
		}

		function removeAttribute(attribute) {
			_.remove(vm.channelType.attributes, function(val) {
				return val.id === attribute.id;
			});
			Restangular.one('channel_type_attributes', attribute.id)
				.remove()
				.then(function() {
					toastr.success('Atributo eliminado con éxito.');
				}, function() {
					vm.channelType.attributes.push(attribute);
				});
		}

		function resetNewAttributeForm() {
			vm.newAttribute = {
				channel_type_id: channelType.id,
				name: null
			};
		}
	}
})();

(function() {
	'use strict';

	angular
	.module('hubAuth', ['hubApi']);
})();

(function() {
	'use strict';

	angular
	.module('hubAuth')
	.factory('hbSession', HbSession);

	function HbSession(Users, AuthManager) {
		var _user = null;

		return {
			promise: promise,
			user: user,
			clear: clear
		};

		function promise() {
			_user = Users.one(AuthManager.id()).get();
			return _user;
		}

		function user() {
			return _user.$object;
		}

		function clear() {
			_user = null;
		}
	}
})();

(function() {
	'use strict';

	angular
	.module('hubAuth')
	.controller('LoginController', LoginController);

	/** @ngInject */
	function LoginController($scope, $rootScope, $state, toastr, AuthManager) {
		var vm = this;

		vm.loginForm = {
			username: null,
			password: null
		};
		vm.ui = {
			loggingIn: false
		};

		vm.login = login;

		activate();

		function activate() {
		}

		function login() {
			vm.ui.loggingIn = true;
			AuthManager.login(vm.loginForm.username, vm.loginForm.password)
			.then(function() {
				$state.go('root.main.dashboard');
				toastr.success('¡Bienvenido!');
			})
			.finally(function() {
				vm.ui.loggingIn = false;
			});
		}
	}
})();

(function() {
	'use strict';

	angular
	.module('hubAuth')
	.config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider) {
		$stateProvider
		.state('root.login', {
			url: '/login',
			templateUrl: 'app/auth/login.html',
			controller: 'LoginController',
			controllerAs: 'vm'
		});
	}
})();

(function() {
	'use strict';

	angular
	.module('hubChannelSettings', []);
})();

(function() {
	angular
	.module('hubChannelSettings')
	.run(runBlock);

	/** @ngInject */
	function runBlock(caMenuService) {
		caMenuService.add({
			route: 'root.main.channelSettings',
			text: 'Canales',
			icon: 'code-fork'
		});
	}
})();

(function() {
	'use strict';

	angular
	.module('hubChannelSettings')
	.config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider, $urlRouterProvider) {
		$stateProvider
		.state('root.main.channelSettings', {
			url: '/channel-settings',
			templateUrl: 'app/channel-settings/channel-settings.html',
			controller: 'ChannelSettingsController',
			controllerAs: 'vm'
		});
	}

})();

(function() {
	'use strict';

	angular
	.module('hubChannelSettings')
	.controller('ChannelSettingsController', ChannelSettingsController);

	/** @ngInject */
	function ChannelSettingsController(
		$q,
		$uibModal,
		toastr,
		Restangular,
		hbConstants,
		ChannelSettings,
		Channels,
		Companies
	) {
		var vm = this;
		vm.activeCompanyId = null;
		vm.channels = [];
		vm.companies = [];
		vm.editedSettings = [];
		vm.hbConstants = hbConstants;
		vm.settings = [];
		vm.ui = {
			savingSettings: false
		};

		vm.addChannelSetting = addChannelSetting;
		vm.createChannelSetting = createChannelSetting;
		vm.editChannelSettingAttributes = editChannelSettingAttributes;
		vm.getChannelSettings = getChannelSettings;
		vm.getChannels = getChannels;
		vm.getUnusedChannels = getUnusedChannels;
		vm.lowerPriority = lowerPriority;
		vm.openChannelSettingAttributesDialog = openChannelSettingAttributesDialog;
		vm.raisePriority = raisePriority;
		vm.removeSetting = removeSetting;
		vm.saveChannelSettings = saveChannelSettings;
		vm.setActiveCompany = setActiveCompany;

		activate();

		function activate() {
			// tmp, should only see companies assigned to user
			vm.companies = hbConstants.asArray('COMPANY');
			setActiveCompany(vm.companies[0].id);

			vm.getChannelSettings();
			vm.getChannels();
		}

		function addChannelSetting(channel) {
			if (channel.type.attributes.length) {
				openChannelSettingAttributesDialog(channel)
					.result
					.then(function(attributes) {
						createChannelSetting(channel, attributes);
					});
			} else {
				createChannelSetting(channel, {});
			}
		}

		function createChannelSetting(channel, attributes) {
			var newSetting = {
				channel_id: channel.id,
				attributes: attributes
			};
			ChannelSettings.post(newSetting, {with: 'channel.status,channel.type.attributes'})
				.then(function(setting) {
					vm.settings.push(setting);
					updateEditedSettings();
					toastr.success('Canal añadido con éxito.');
				})
				.finally(function() {});
		}

		/**
		 * Updates the attributes of the specified
		 * channel setting.
		 * 
		 * @param  {ChannelSetting} setting
		 */
		function editChannelSettingAttributes(setting)
		{
			openChannelSettingAttributesDialog(setting.channel, setting.attributes)
				.result
				.then(function (attributes) {
					setting.attributes = attributes;

					setting.put({with: 'channel.status,channel.type.attributes'})
						.then(function () {
							toastr.success('Atributos actualizados con éxito.');
						});
				});
		}

		function getChannelSettings() {
			ChannelSettings.getList({with: 'channel.status,channel.type.attributes'})
				.then(function(settings) {
					vm.settings = settings;
					updateEditedSettings();
				});
		}

		function getChannels() {
			Channels.getList({with: 'status,type.attributes'})
				.then(function(channels) {
					vm.channels = channels;
				});
		}

		function getUnusedChannels() {
			var usedIds = _.map(vm.editedSettings, 'channel_id');
			return	_.filter(vm.channels, function(val) {
				return val.company_id === vm.activeCompanyId && usedIds.indexOf(val.id) < 0;
			});
		}

		function lowerPriority(setting) {
			if (vm.editedSettings.length < 2) {
				return;
			}

			var idx = _.findIndex(vm.editedSettings, function(s) { return s.id === setting.id;});
			if (idx === vm.editedSettings.length - 1) {
				return;
			}

			var from;
			var to;
			if (idx === vm.editedSettings.length - 2) {
				var maxPriority = vm.editedSettings[idx + 1].priority;
				vm.editedSettings[idx + 1].priority = setting.priority;
				setting.priority = maxPriority;
			} else {
				from = vm.editedSettings[idx + 1].priority;
				to = vm.editedSettings[idx + 2].priority;
				setting.priority = (to - from) / 2;
			}

			sortSettings();
		}

		function openChannelSettingAttributesDialog(channel, attributes) {
			return $uibModal.open({
				controller: 'AttributesModalController',
				controllerAs: 'vm',
				resolve: {
					channel: channel,
					attributes: attributes
				},
				templateUrl: 'app/channel-settings/attributes-modal.html',
			});
		}

		function raisePriority(setting) {
			if (vm.editedSettings.length < 2) {
				return;
			}

			var idx = _.findIndex(vm.editedSettings, function(s) { return s.id === setting.id;});
			if (idx === 0) {
				return;
			}

			var from;
			var to;
			if (idx === 1) {
				from = 0;
				to = vm.editedSettings[idx - 1].priority;
			} else {
				from = vm.editedSettings[idx - 2].priority;
				to = vm.editedSettings[idx - 1].priority;
			}

			setting.priority = (to - from) / 2;
			sortSettings();
		}

		function removeSetting(setting) {
			_.remove(vm.settings, function(val) {
				return val.id === setting.id;
			});
			updateEditedSettings();

			Restangular.one('channel_settings', setting.id)
				.remove()
				.then(function() {
					toastr.success('Canal eliminado con éxito.');
				}, function() {
					/* jshint ignore:start */
					vm.company.channels.push(channel);
					/* jshint ignore:end */
					updateEditedSettings();
				});
		}

		function saveChannelSettings() {
			var promises = [];
			_.each(vm.editedSettings, function(val) {
				promises.push(val.save());
			});

			vm.ui.savingSettings = true;
			$q.all(promises)
				.then(function() {
					toastr.success('Canales guardados con éxito.');
				})
				.finally(function() {
					vm.ui.savingSettings = false;
				});
		}

		function setActiveCompany(companyId) {
			vm.activeCompanyId = companyId;
			updateEditedSettings();
		}

		function sortSettings() {
			vm.editedSettings = _.sortBy(vm.editedSettings, 'priority');
		}

		function updateEditedSettings() {
			vm.editedSettings = _.filter(vm.settings, function(val) {
				return val.channel.company_id === vm.activeCompanyId;
			});
		}
	}
})();

(function() {
	'use strict';

	angular
	.module('hubChannelSettings')
	.controller('AttributesModalController', AttributesModalController);

	/** @ngInject */
	function AttributesModalController($uibModalInstance, channel, attributes) {
		var vm = this;
		vm.attributeValues = attributes;
		vm.channel = channel;

		vm.cancel = cancel;
		vm.ok = ok;

		activate();

		////////////////

		function activate() {
		}

		function cancel() {
			$uibModalInstance.dismiss('cancel');
		}

		function ok() {
			$uibModalInstance.close(vm.attributeValues);
		}
	}
})();

(function() {
	'use strict';

	angular
	.module('hubApi', ['restangular'])
	.config(HubConfig)
	.factory('Channels', Channels)
	.factory('ChannelSettings', ChannelSettings)
	.factory('ChannelTypeAttributes', ChannelTypeAttributes)
	.factory('ChannelTypes', ChannelTypes)
	.factory('Companies', Companies)
	.factory('Constants', Constants)
	.factory('Deliveries', Deliveries)
	.factory('UserSettings', UserSettings)
	.factory('Users', Users);

	/** @ngInject */
	function HubConfig(RestangularProvider) {
		RestangularProvider.extendModel('deliveries', function (delivery) {
			delivery.addRestangularMethod('repeat', 'post', 'repeat');
			return delivery;
		});
	}

	/** @ngInject */
	function Channels(Restangular) {
		return Restangular.service('channels');
	}

	/** @ngInject */
	function ChannelSettings(Restangular) {
		return Restangular.service('channel_settings');
	}

	/** @ngInject */
	function ChannelTypeAttributes(Restangular) {
		return Restangular.service('channel_type_attributes');
	}

	/** @ngInject */
	function ChannelTypes(Restangular) {
		return Restangular.service('channel_types');
	}

	/** @ngInject */
	function Companies(Restangular) {
		return Restangular.service('companies');
	}

	/** @ngInject */
	function Constants(Restangular) {
		return Restangular.service('constants');
	}

	/** @ngInject */
	function Deliveries(Restangular) {
		return Restangular.service('deliveries');
	}

	/** @ngInject */
	function UserSettings(Restangular) {
		return Restangular.service('user_settings');
	}

	/** @ngInject */
	function Users(Restangular) {
		return Restangular.service('users');
	}
})();

(function() {
	'use strict';

	angular
	.module('hubApi')
	.factory('hbConstants', HbConstants);

	/** @ngInject */
	function HbConstants($log, $q, Restangular) {
		var vals = {};

		var service = {
			promise: promise,
			get: get,
			byId: byId,
			asArray: asArray
		};

		return service;

		function promise() {
			return Restangular.all('constants')
				.customGET('')
				.then(function(data) {
					vals = data.plain();
					angular.forEach(data.plain(), function(v, k) {
						angular.forEach(vals[k], function(value, key) {
							value.key = key.toLowerCase();
						});
						// vals[k].byId = function(id) {
						// 	return findById(v, parseInt(id));
						// }
					});
				});
		}

		function get() {
			return vals;
		}

		function byId(key, id) {
			if (! vals.hasOwnProperty(key)) {
				$log.error('No key found: ' + key);
				return null;
			}

			for (var k in vals[key]) {
				if (vals[key][k].id === id) {
					return vals[key][k];
				}
			}

			$log.error('ID ' + id + ' not found for key ' + key);
			return null;
		}

		function asArray(key) {
			if (! vals.hasOwnProperty(key)) {
				$log.error('No key found: ' + key);
				return null;
			}

			return _.map(vals[key], function(v) {return v;});
		}
	}
})();


(function() {
	'use strict';

	angular
	.module('hub')
	.run(runBlock);

	/** @ngInject */
	function runBlock($rootScope, $state, toastr, AuthManager, caMenuService) {
		// globally handle error events thrown by our http interceptor
		$rootScope.$on('httpError', function(event, httpResponse) {
			var msg = null;
			if (typeof(httpResponse.data) !== 'undefined' && httpResponse.data !== null) {
				msg = httpResponse.data.description;
				if (httpResponse.data.validation_errors) {
					msg += ': ' + httpResponse.data.validation_errors[0];
				}
			} else {
				msg = 'Se ha producido un error desconocido';
			}

			toastr.error(msg);

			if (httpResponse.status === 401) {
				$state.go('root.login');
			}
		});

		/*
		 * State change handlers:
		 *  - if already logged in, prevent the user from
		 *    going to the login page.
		 *  - if not logged in, keep the user within the
		 *    login page.
		 */
		$rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
			if (toState.name === 'root.login' &&
				AuthManager.isLoggedIn()
			) {
				event.preventDefault();
				if (! fromState.name || fromState.name.length <= 0) {
					$state.go('root.main.dashboard');
				}
			} else if (toState.name !== 'root.login' &&
				!AuthManager.isLoggedIn()
			) {
				event.preventDefault();
				$state.go('root.login');
			}
		});

		caMenuService.add({
			route: 'root.main.dashboard',
			text: 'Dashboard',
			icon: 'dashboard',
			order: 1
		});
	}

})();

(function() {
	'use strict';

	angular
	.module('hub')
	.config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider, $urlRouterProvider) {
		$stateProvider
		.state('root', {
			abstract: true,
			template: '<ui-view/>'
		})
		.state('root.main', {
			abstract: true,
			templateUrl: 'app/main/main.html',
			controller: 'MainController',
			controllerAs: 'vm',
			resolve: {
				constants: function(hbConstants) {
					return hbConstants.promise();
				},
				session: function(hbSession) {
					return hbSession.promise();
				}
			}
		})
		.state('root.main.dashboard', {
			url: '/',
			templateUrl: 'app/dashboard/dashboard.html',
			controller: 'DashboardController',
			controllerAs: 'vm'
		});

		$urlRouterProvider.otherwise('/');
	}

})();

/* moment:false */
(function() {
	'use strict';

	angular
	.module('hub')
	.constant('moment', moment)
	.constant('hbConfig', {
		apiEndpoint: 'https://api.hub.e-valua.es'
	});
})();

(function() {
	'use strict';

	angular
	.module('hub')
	.config(config);

	/** @ngInject */
	function config (
		$logProvider,
		$stateProvider,
		$urlRouterProvider,
		$httpProvider,
		toastrConfig,
		RestangularProvider,
		AuthManagerProvider,
		AuthInterceptorProvider,
		hbConfig
	) {
		// Enable log
		$logProvider.debugEnabled(true);

		// Set options third-party lib
		toastrConfig.allowHtml = true;
		toastrConfig.timeOut = 3000;
		toastrConfig.positionClass = 'toast-top-right';
		toastrConfig.preventOpenDuplicates = true;
		toastrConfig.progressBar = true;

		// restanguar config
		RestangularProvider.setBaseUrl(hbConfig.apiEndpoint);
		RestangularProvider.addResponseInterceptor(parsePaginatedResponses);

		function parsePaginatedResponses(data, operation, what, url, response, deferred) {
			response = data;
			if (operation === 'getList' &&
				Object.prototype.toString.call(data) === '[object Object]') {
				response = data.data;
				response.metadata = _.omit(data, 'data');
			}
			return response;
		}

		$httpProvider.interceptors.push(function($q, $rootScope, $window, $location, AuthManagerStorage) {
			return {
				request: function(config) {
					return config;
				},
				responseError: function(rejection) {
					if (rejection.status === 401) {
						if ($location.path().indexOf('login') < 0) {
							if (AuthManagerStorage.cleanUrl(rejection.config.url) === hbConfig.apiEndpoint) {
								$location.path('login');
							}
						}
					}

					$rootScope.$broadcast('httpError', rejection);
					return $q.reject(rejection);
				}
			};
		});

		// auth interceptor
		AuthInterceptorProvider.registerHost(hbConfig.apiEndpoint);

		$httpProvider.interceptors.push(function (AuthInterceptor) {
			return AuthInterceptor;
		});

		AuthManagerProvider.setApiEndpoint(hbConfig.apiEndpoint);
	}
})();

(function() {
	'use strict';

	angular
		.module('hub')
		.factory('hbDeliveryUtils', hbDeliveryUtils);

	hbDeliveryUtils.$inject = ['hbConstants', 'toastr', '$q', '$uibModal'];

	/** @ngInject */
	function hbDeliveryUtils(hbConstants, toastr, $q, $uibModal) {
		var service = {
			canRepeat: canRepeat,
			repeat: repeat,
			canCanceled: canCanceled,
			canceled: canceled
		};

		return service;

		////////////////

		/**
		 * If the delivery has already been delivered,
		 * shows a confirmation modal before repeating
		 * the delivery and returns a promise with the
		 * modal result.
		 *
		 * Otherwise this function returns a promise
		 * which will be immediately resolved.
		 *
		 * @param {Object} delivery
		 * @return {Promise}
		 */
		function askForRepeatConfirmation(delivery) {
			// only ask for confirmation if delivery has already been delivered
			if (delivery.delivery_status_id === hbConstants.get().DELIVERY_STATUS.DELIVERED.id) {
				return $uibModal.open({
					controller: 'RepeatDeliveryConfirmationModalController',
					templateUrl: 'app/deliveries/repeat-delivery-confirmation-modal.html'
				}).result;
			}

			// otherwise just simulate the modal
			var deferred = $q.defer();
			deferred.resolve('ok');
			return deferred.promise;
		}

		/**
		 * Returns whether the current delivery can
		 * be repeated.
		 *
		 * @param {Object} delivery
		 * @return {Boolean}
		 */
		function canRepeat(delivery) {
			var allowedStatus = [
				hbConstants.get().DELIVERY_STATUS.FAILED.id,
				hbConstants.get().DELIVERY_STATUS.DELIVERED.id
			];
			return allowedStatus.indexOf(delivery.delivery_status_id) >= 0;
		}

		/**
		 * Puts this delivery back in the queue.
		 *
		 * @param {Object} delivery
		 * @return {Promise}
		 */
		function repeat(delivery) {
			return askForRepeatConfirmation(delivery).then(onRepeatConfirmation)
				.then(onRepeatSuccess);

			function onRepeatConfirmation() {
				return delivery.repeat();
			}

			function onRepeatSuccess() {
				delivery.delivery_status_id = hbConstants.get().DELIVERY_STATUS.QUEUED.id;
				toastr.success('El envío ha sido encolado de nuevo');
			}
		}

		/**
		 * Returns whether the current delivery can
		 * be canceled.
		 *
		 * @param {Object} delivery
		 * @return {Boolean}
		 */
		function canCanceled(delivery) {
			var allowedStatus = [
				hbConstants.get().DELIVERY_STATUS.QUEUED.id,
				hbConstants.get().DELIVERY_STATUS.IN_PROGRESS.id,
				hbConstants.get().DELIVERY_STATUS.FAILED.id
			];
			return allowedStatus.indexOf(delivery.delivery_status_id) >= 0;
		}

		/**
		 * Cancels the current delivery.
		 *
		 * @param {Object} delivery
		 * @return {Promise}
		 */
		function canceled(delivery) {
			var originalStatusId = delivery.delivery_status_id;

			delivery.remove()
				.then(function() {
					delivery.delivery_status_id = hbConstants.get().DELIVERY_STATUS.CANCELED.id;
					toastr.success('El envío ha sido cancelado con éxito');
				})
				.catch(function() {
					delivery.delivery_status_id = originalStatusId;
				});
		}
	}
})();


angular.module("hub").run(["$templateCache", function($templateCache) {$templateCache.put("app/auth/login.html","<div class=\"content login-page\"><div class=\"col-md-4 col-md-offset-4\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><h3 class=\"panel-title\">Panel de gestión del Hub</h3></div><div class=\"panel-body\"><p>Bienvenido. Para continuar, es necesario que inicie sesión.</p><form name=\"loginForm\" class=\"form-horizontal\" ng-submit=\"vm.login()\"><div class=\"form-group\"><label class=\"col-md-3 control-label\">Usuario</label><div class=\"col-md-9\"><input type=\"text\" name=\"username\" class=\"form-control\" ng-model=\"vm.loginForm.username\"></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">Contraseña</label><div class=\"col-md-9\"><input type=\"password\" name=\"password\" class=\"form-control\" ng-model=\"vm.loginForm.password\"></div></div><div class=\"form-group\"><div class=\"col-md-9 col-md-offset-3\"><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"vm.ui.loggingIn\"><span ng-if=\"vm.ui.loggingIn\"><i class=\"fa fa-fw fa-circle-o-notch fa-spin\"></i> Autenticando...</span> <span ng-if=\"! vm.ui.loggingIn\">Iniciar sesión</span></button></div></div></form></div></div></div></div>");
$templateCache.put("app/channel-types/channel-type-detail.html","<h1 class=\"page-header\">{{ ::vm.channelType.name }}</h1><uib-tabset><uib-tab heading=\"Atributos\"><h3>Atributos</h3><p>Defina a continuación los atributos utilizados para configurar este tipo de canal.</p><form class=\"form form-horizontal\" name=\"newAttributeForm\" ng-submit=\"vm.addAttribute()\"><div class=\"form-group\"><label class=\"col-md-3 control-label\">Nombre</label><div class=\"col-md-5\"><input class=\"form-control\" type=\"text\" name=\"name\" required=\"\" ng-disabled=\"vm.ui.addingAttribute\" ng-model=\"vm.newAttribute.name\"></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-5\"><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"vm.ui.addingAttribute || newAttributeForm.$invalid\"><span ng-if=\"vm.ui.addingAttribute\"><i class=\"fa fa-fw fa-circle-o-notch fa-spin\"></i>Añadiendo...</span> <span ng-if=\"! vm.ui.addingAttribute\">Añadir atributo</span></button></div></div></form><table class=\"table table-striped\" ng-if=\"vm.channelType.attributes.length > 0\"><thead><tr><th>Nombre</th><th></th></tr></thead><tbody><tr ng-repeat=\"attribute in vm.channelType.attributes\"><td>{{ ::attribute.name }}</td><td><a href=\"\" ng-click=\"vm.removeAttribute(attribute)\"><i class=\"fa fa-fw fa-trash\"></i>Eliminar</a></td><td></td></tr></tbody></table><div class=\"alert alert-info\" ng-if=\"vm.channelType.attributes.length === 0\"><p><i class=\"fa fa-fw fa-info-circle\"></i>Este tipo de canal no tiene ningún atributo definido.</p></div></uib-tab></uib-tabset>");
$templateCache.put("app/channel-types/channel-types.html","<div ui-view=\"\"><h1 class=\"page-header\">Tipos de canal</h1><table class=\"table\"><thead><tr><th>Tipo</th></tr></thead><tbody><tr ng-repeat=\"type in ::vm.hbConstants.get().CHANNEL_TYPE\"><td><a ui-sref=\"root.main.channelTypes.detail({channelTypeId: type.id})\">{{ ::type.name }}</a></td></tr></tbody></table></div>");
$templateCache.put("app/channel-settings/attributes-modal.html","<form class=\"form-horizontal\" name=\"channelSettingAttributesForm\" ng-submit=\"vm.ok()\"><div class=\"modal-header\"><h3 class=\"modal-title\">Configuración de atributos</h3></div><div class=\"modal-body\"><p>Los canales de tipo <strong>{{ ::vm.channel.type.name }}</strong> necesitan que configure los siguientes atributos para operar correctamente. Podrá editar los valores más adelante.</p><div class=\"form-group\" ng-repeat=\"attribute in ::vm.channel.type.attributes\"><label class=\"col-md-4 control-label\" for=\"\">{{ ::attribute.name }}</label><div class=\"col-md-8\"><input type=\"text\" class=\"form-control\" ng-required=\"attribute.name != \'CC\'\" ng-model=\"vm.attributeValues[attribute.name]\"></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" type=\"submit\" ng-disabled=\"channelSettingAttributesForm.$invalid\">Guardar cambios</button> <button class=\"btn btn-link\" type=\"button\" ng-click=\"vm.cancel()\">Cancelar</button></div></form>");
$templateCache.put("app/channel-settings/channel-settings.html","<h1 class=\"page-header\">Canales</h1><ul class=\"nav nav-pills\"><li ng-repeat=\"company in ::vm.companies\" ng-click=\"vm.setActiveCompany(company.id)\" ng-class=\"{\'active\': vm.activeCompanyId === company.id}\"><a href=\"\">{{ company.name }}</a></li></ul><h3>Canales existentes</h3><p>Haga click en las flechas para modificar el orden de prioridad de los canales. Haga click en la casilla para activar y desactivar un canal concreto.</p><form ng-if=\"vm.editedSettings.length > 0\"><div class=\"list-group\"><div class=\"list-group-item\" ng-repeat=\"setting in vm.editedSettings\" ng-class=\"{\'hb-channel-disabled\': setting.enabled == false}\"><p class=\"list-group-item-text\"><span class=\"fa-fw pull-left\"><input type=\"checkbox\" ng-model=\"setting.enabled\"></span> <span><hb-channel-status-icon status=\"setting.channel.status.id\"></hb-channel-status-icon>{{ ::setting.channel.type.name }}</span> <span class=\"pull-right\"><a href=\"\" uib-tooltip=\"Aumentar prioridad\" tooltip-class=\"top-tooltip-fix\" ng-click=\"vm.raisePriority(setting)\"><i class=\"fa fa-fw fa-single fa-arrow-up\"></i></a> <a href=\"\" uib-tooltip=\"Reducir prioridad\" tooltip-class=\"top-tooltip-fix\" ng-click=\"vm.lowerPriority(setting)\"><i class=\"fa fa-fw fa-single fa-arrow-down\"></i></a> <a href=\"\" uib-tooltip=\"Editar atributos\" tooltip-class=\"top-tooltip-fix\" ng-click=\"vm.editChannelSettingAttributes(setting)\"><i class=\"fa fa-fw fa-single fa-edit\"></i></a> <a href=\"\" uib-tooltip=\"Eliminar canal\" tooltip-class=\"top-tooltip-fix\" ng-click=\"vm.removeSetting(setting)\"><i class=\"fa fa-fw fa-single fa-trash\"></i></a></span></p></div></div><div class=\"form-group\"><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"vm.ui.savingSettings\" ng-click=\"vm.saveChannelSettings()\"><span ng-if=\"vm.ui.savingSettings\"><i class=\"fa fa-fw fa-circle-o-notch fa-spin\"></i>Guardando cambios...</span> <span ng-if=\"! vm.ui.savingSettings\">Guardar cambios</span></button></div></form><div class=\"alert alert-info\" ng-if=\"vm.editedSettings.length === 0\"><p><i class=\"fa fa-fw fa-info-circle\"></i>No está utilizando ningún canal en {{ vm.hbConstants.byId(\'COMPANY\', vm.activeCompanyId).name }}. Configure uno para poder enviar comunicaciones a esta compañía.</p></div><h3>Añadir un nuevo canal</h3><p>Estos son los canales disponibles para {{ vm.hbConstants.byId(\'COMPANY\', vm.activeCompanyId).name }} pero que usted no está utilizando. Si desea añadir alguno, haga click en <i class=\"fa fa-plus\"></i>.</p><div class=\"list-group\"><div class=\"list-group-item\" ng-repeat=\"channel in vm.getUnusedChannels()\"><p class=\"list-group-item-text\"><span><hb-channel-status-icon status=\"channel.status.id\"></hb-channel-status-icon>{{ ::channel.type.name }}</span> <span class=\"pull-right\"><a href=\"\" uib-tooltip=\"Añadir canal\" tooltip-class=\"top-tooltip-fix\" ng-click=\"vm.addChannelSetting(channel)\"><i class=\"fa fa-fw fa-plus\"></i></a></span></p></div></div><div class=\"alert alert-info\" ng-if=\"vm.getUnusedChannels().length === 0\"><p><i class=\"fa fa-fw fa-info-circle\"></i>Ya ha configurado todos los canales disponibles para {{ vm.hbConstants.byId(\'COMPANY\', vm.activeCompanyId).name }}.</p></div>");
$templateCache.put("app/companies/companies.html","<div ui-view=\"\"><h1 class=\"page-header\">Compañías</h1><table class=\"table table-striped\"><thead><tr><th>Compañía</th></tr></thead><tbody><tr ng-repeat=\"company in vm.companies\"><td><a ui-sref=\"root.main.companies.detail({companyId: company.id})\">{{ ::company.name }}</a></td></tr></tbody></table></div>");
$templateCache.put("app/companies/company-detail.html","<h1 class=\"page-header\">{{ vm.company.name }}</h1><div class=\"row\"><div class=\"col-md-12\"><uib-tabset><uib-tab heading=\"Canales\"><h3>Canales disponibles</h3><p>Seleccione a continuación qué canales pueden usarse para enviar comunicaciones a esta compañía.</p><form class=\"form form-horizontal\" name=\"newChannelForm\" ng-if=\"vm.getUnusedChannelTypes().length > 0\" ng-submit=\"vm.addChannel()\"><div class=\"form-group\"><label class=\"col-md-3 control-label\">Tipo de canal</label><div class=\"col-md-5\"><select class=\"form-control\" required=\"\" ng-options=\"type.id as type.name for type in vm.getUnusedChannelTypes() track by type.id\" ng-model=\"vm.newChannel.channel_type_id\"><option value=\"\">Seleccione un tipo de canal...</option></select></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-5\"><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"vm.ui.addingChannel || newChannelForm.$invalid\"><span ng-if=\"vm.ui.addingChannel\"><i class=\"fa fa-fw fa-circle-o-notch fa-spin\"></i>Creando...</span> <span ng-if=\"! vm.ui.addingChannel\">Crear canal</span></button></div></div></form><div class=\"alert alert-info\" ng-if=\"vm.getUnusedChannelTypes().length === 0\"><p><i class=\"fa fa-fw fa-info-circle\"></i>Esta compañía ya hace uso de todos los tipos de canales disponibles.</p></div><table class=\"table table-striped\" ng-if=\"vm.company.channels.length > 0\"><thead><tr><th>Tipo de canal</th><th></th></tr></thead><tbody><tr ng-repeat=\"channel in vm.company.channels\"><td>{{ ::channel.type.name }}</td><td><a href=\"\" ng-click=\"vm.removeChannel(channel)\"><i class=\"fa fa-fw fa-trash\"></i>Eliminar</a></td></tr></tbody></table><div class=\"alert alert-warning\" ng-if=\"vm.company.channels.length === 0\"><p><i class=\"fa fa-fw fa-exclamation-triangle\"></i>Esta compañía no tiene ningún canal.</p></div></uib-tab><uib-tab heading=\"Tipos de envío\"><h3>Tipos de envío</h3><p>Seleccione qué tipos de envío permite esta compañía para cada canal.</p><table class=\"table table-striped\"><thead><tr><th></th><th ng-repeat=\"channel in vm.company.channels\">{{ channel.type.name }}</th></tr></thead><tbody><tr ng-repeat=\"type in ::vm.hbConstants.get().DELIVERY_TYPE\"><td>{{ ::type.name }}</td><td ng-repeat=\"channel in vm.company.channels\"><input type=\"checkbox\" ng-model=\"vm.channelDeliveryTypes[channel.id][type.id]\"></td></tr></tbody></table></uib-tab></uib-tabset></div><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.saveChannelDeliveryTypes()\" ng-disabled=\"vm.ui.savingChannelDeliveryTypes\"><span ng-if=\"vm.ui.savingChannelDeliveryTypes\"><i class=\"fa fa-fw fa-circle-o-notch fa-spin\"></i>Guardando...</span> <span ng-if=\"! vm.ui.savingChannelDeliveryTypes\">Guardar</span></button></div>");
$templateCache.put("app/dashboard/dashboard.html","<h1 class=\"page-header\">Dashboard</h1><div class=\"row\"><div class=\"col-md-6\"><div class=\"panel panel-green\"><div class=\"panel-heading\"><div class=\"row\"><div class=\"col-xs-3\"><i class=\"fa fa-check fa-5x\"></i></div><div class=\"col-xs-9 text-right\"><div class=\"hb-huge\">{{ vm.stats.deliveredToday }}</div><div>envíos exitosos hoy</div></div></div></div></div></div><div class=\"col-md-6\"><div class=\"panel panel-red\"><div class=\"panel-heading\"><div class=\"row\"><div class=\"col-xs-3\"><i class=\"fa fa-exclamation-circle fa-5x\"></i></div><div class=\"col-xs-9 text-right\"><div class=\"hb-huge\">{{ vm.stats.failedToday }}</div><div>envíos fallidos hoy</div></div></div></div></div></div></div><h3>Entregados vs. fallidos (últimos 14 días)</h3><div class=\"alert alert-info\" ng-if=\"!vm.stats.breakdown.data\"><p><i class=\"fa fa-fw fa-info-circle\"></i>No hay datos que mostrar.</p></div><canvas id=\"chart\" class=\"chart chart-line\" chart-data=\"vm.stats.breakdown.data\" chart-labels=\"vm.stats.breakdown.labels\" chart-series=\"vm.stats.breakdown.series\" chart-colors=\"vm.stats.breakdown.colors\"></canvas>");
$templateCache.put("app/customers/customer-detail.html","<h1 class=\"page-header\">{{ vm.customer.username }}</h1><div class=\"row\"><div class=\"col-md-12\"><h3>Compañías asignadas</h3><p>Seleccione con qué compañías puede comunicarse este cliente.</p><form class=\"form-horizontal\" ng-submit=\"vm.saveCompanies()\"><div class=\"form-group\" ng-repeat=\"company in ::vm.hbConstants.get().COMPANY\"><div class=\"col-md-offset-3 col-md-5\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.companies[company.id]\"> {{ ::company.name }}</label></div></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-5\"><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"vm.ui.savingCompanies\"><span ng-if=\"vm.ui.savingCompanies\"><i class=\"fa fa-fw fa-circle-o-notch fa-spin\"></i>Guardando...</span> <span ng-if=\"! vm.ui.savingCompanies\">Guardar</span></button></div></div></form></div></div>");
$templateCache.put("app/customers/customers.html","<div ui-view=\"\"><h1 class=\"page-header\">Clientes</h1><table class=\"table table-striped\"><thead><tr><th>Cliente</th><th>Fecha de creación</th></tr></thead><tbody><tr ng-repeat=\"customer in vm.customers\"><td><a ui-sref=\"root.main.customers.detail({customerId: customer.id})\">{{ ::customer.username }}</a></td><td>{{ ::customer.created_at | amDateFormat:\'DD/MM/YY HH:mm:ss\' }}</td></tr></tbody></table></div>");
$templateCache.put("app/deliveries/create-delivery.html","<h1 class=\"page-header\">Nuevo envío</h1><form class=\"form-horizontal\" name=\"newDeliveryForm\" ng-submit=\"vm.createDelivery()\"><div class=\"form-group\"><label for=\"companyId\" class=\"col-md-3 control-label\">Compañía</label><div class=\"col-md-5\"><select id=\"companyId\" class=\"form-control\" required=\"\" ng-model=\"vm.newDelivery.company_id\" ng-options=\"company.id as company.name for company in vm.hbConstants.get().COMPANY track by company.id\"><option value=\"\">Seleccione una compañía...</option></select></div></div><div class=\"form-group\"><label for=\"deliveryTypeId\" class=\"col-md-3 control-label\">Tipo de envío</label><div class=\"col-md-5\"><select id=\"deliveryTypeId\" class=\"form-control\" required=\"\" ng-model=\"vm.newDelivery.delivery_type_id\" ng-options=\"type.id as type.name for type in vm.hbConstants.get().DELIVERY_TYPE track by type.id\"><option value=\"\">Seleccione un tipo de envío...</option></select></div></div><div class=\"form-group\"><label for=\"claimNumber\" class=\"col-md-3 control-label\">Número de siniestro</label><div class=\"col-md-5\"><input id=\"claimNumber\" type=\"text\" class=\"form-control\" required=\"\" ng-model=\"vm.newDelivery.claim_number\"></div></div><div class=\"form-group\"><label for=\"policyNumber\" class=\"col-md-3 control-label\">Número de póliza</label><div class=\"col-md-5\"><input id=\"policyNumber\" type=\"text\" class=\"form-control\" required=\"\" ng-model=\"vm.newDelivery.policy_number\"></div></div><div class=\"form-group\"><label for=\"metadata\" class=\"col-md-3 control-label\">Metadatos</label><div class=\"col-md-9\"><textarea id=\"metadata\" rows=\"4\" class=\"form-control\" required=\"\" ng-model=\"vm.newDelivery.metadata\"></textarea></div></div><div class=\"form-group\"><label for=\"settingOverrides\" class=\"col-md-3 control-label\">Configuración de canal</label><div class=\"col-md-9\"><textarea id=\"settingOverrides\" rows=\"4\" class=\"form-control\" ng-model=\"vm.newDelivery.setting_overrides\"></textarea><p class=\"help-block\">Puede sobreescribir los parámetros de configuración de los canales para este envío en concreto. Indique los atributos en formato JSON.</p></div></div><div class=\"form-group\"><label for=\"attachments\" class=\"col-md-3 control-label\">Adjuntos</label><div class=\"col-md-9\"><div class=\"input-group\"><label class=\"input-group-btn\"><span class=\"btn btn-default\">Examinar&hellip; <input type=\"file\" multiple=\"\" style=\"display: none\" base-sixty-four-input=\"\" ng-model=\"vm.selectedFiles\"></span></label> <input type=\"text\" class=\"form-control\" value=\"{{ vm.getSelectedFiles() }}\" readonly=\"\"></div></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-5\"><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"newDeliveryForm.$invalid\"><span ng-if=\"vm.ui.creatingDelivery\"><i class=\"fa fa-fw fa-circle-o-notch fa-spin\"></i>Creando envío...</span> <span ng-if=\"! vm.ui.creatingDelivery\">Crear envío</span></button></div></div></form>");
$templateCache.put("app/deliveries/deliveries.html","<div ui-view=\"\"><h1 class=\"page-header\"><span>Envíos</span></h1><div class=\"row\"><div class=\"col-md-6\"><ui-select multiple=\"\" ng-model=\"vm.selectedStatus\" theme=\"bootstrap\" ng-disabled=\"ctrl.disabled\" close-on-select=\"false\" title=\"Choose a status\" on-select=\"vm.filterByStatus()\" on-remove=\"vm.filterByStatus()\"><ui-select-match class=\"ui-select-match\" placeholder=\"Filtra por estado...\">{{ $item.name }}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"status in vm.getDeliveryStatus() | filter: $select.search\">{{ status.name }}</ui-select-choices></ui-select></div><div class=\"col-md-6\"><div class=\"btn-toolbar\"><div class=\"btn-group\"><form name=\"searchForm\" class=\"form-inline\" novalidate=\"\" ng-submit=\"vm.search()\"><div class=\"input-group\"><input class=\"form-control\" type=\"text\" ng-model=\"vm.searchForm.claimNumber\" placeholder=\"Buscar por siniestro...\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" uib-tooltip=\"Limpiar búsqueda\" ng-click=\"vm.clearSearch()\"><i class=\"fa fa-remove\"></i></button></span></div></form></div><div class=\"btn-group pull-right\"><a class=\"btn btn-primary\" ui-sref=\"root.main.deliveries.create\"><i class=\"fa fa-fw fa-send\"></i>Nuevo envío</a></div></div></div></div><div ng-if=\"vm.deliveries.length > 0\"><table class=\"table table-striped\"><thead><tr><th>Tipo de envío</th><th>Compañía</th><th>Siniestro</th><th>Estado</th><th>Fecha y hora</th><th></th></tr></thead><tbody><tr ng-repeat=\"delivery in vm.deliveries\"><td><a ui-sref=\"root.main.deliveries.detail({deliveryId: delivery.id})\">{{ vm.hbConstants.byId(\'DELIVERY_TYPE\', delivery.delivery_type_id).name }}</a></td><td>{{ vm.hbConstants.byId(\'COMPANY\', delivery.company_id).name }}</td><td><a href=\"\" ng-click=\"vm.filterByClaimNumber(delivery.claim_number)\" target=\"_blank\" uib-tooltip=\"Filtrar por este siniestro\">{{ ::delivery.claim_number }}</a></td><td><span class=\"label {{ vm.getDeliveryStatusBadgeClass(delivery.delivery_status_id) }}\">{{ vm.hbConstants.byId(\'DELIVERY_STATUS\', delivery.delivery_status_id).name }}</span></td><td>{{ ::delivery.created_at | amDateFormat:\'DD/MM/YY HH:mm:ss\' }}</td><td><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a href=\"\" id=\"simple-dropdown\" uib-dropdown-toggle=\"\"><i class=\"fa fa-fw fa-ellipsis-v\"></i></a><ul class=\"uib-dropdown-menu\" aria-labelledby=\"simple-dropdown\"><li ng-class=\"{disabled: !vm.canRepeatDelivery(delivery)}\"><a href=\"\" ng-click=\"vm.canRepeatDelivery(delivery) ? vm.repeatDelivery(delivery) : \'\'\"><i class=\"fa fa-fw fa-refresh\"></i>Repetir envío</a></li><li ng-class=\"{disabled: !vm.canCancelDelivery(delivery)}\"><a href=\"\" ng-click=\"vm.canCancelDelivery(delivery) ? vm.cancelDelivery(delivery) : \'\'\"><i class=\"fa fa-fw fa-ban\"></i>Cancelar envío</a></li></ul></span></td></tr></tbody></table></div><div class=\"alert alert-info\" ng-if=\"vm.deliveries.length === 0\"><p><i class=\"fa fa-fw fa-info-circle\"></i>No hay ningún envío. Haga click en <strong>Nuevo envío</strong> para crear uno.</p></div><div class=\"pagination\"><button ng-click=\"vm.previous()\">«</button> <input type=\"text\" ng-model=\"vm.page\"> <button ng-click=\"vm.next()\">»</button></div></div><script type=\"text/ng-template\" id=\"app/deliveries/repeat-delivery-confirmation-modal.html\"><div class=\"modal-header\"> <h3 class=\"modal-title\">¿Repetir envío?</h3> </div> <div class=\"modal-body\"> <p>Parece que este envío ya ha sido entregado con éxito. ¿Desea repetirlo en cualquier caso?</p> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\">Cancelar</button> <button class=\"btn btn-primary\" type=\"button\" ng-click=\"ok()\">Sí, repetir envío</button> </div></script>");
$templateCache.put("app/deliveries/delivery-detail.html","<h1 class=\"page-header\"><div class=\"pull-right\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\" class=\"delivery-options\"><a href=\"\" id=\"simple-dropdown\" uib-dropdown-toggle=\"\"><i class=\"fa fa-fw fa-ellipsis-v\"></i></a><ul class=\"uib-dropdown-menu\" aria-labelledby=\"simple-dropdown\"><li ng-class=\"{disabled: !vm.canRepeatDelivery(delivery)}\"><a href=\"\" ng-click=\"vm.canRepeatDelivery(delivery) ? vm.repeatDelivery(delivery) : \'\'\"><i class=\"fa fa-fw fa-refresh\"></i>Repetir envío</a></li><li ng-class=\"{disabled: !vm.canCancelDelivery(delivery)}\"><a href=\"\" ng-click=\"vm.canCancelDelivery(delivery) ? vm.cancelDelivery(delivery) : \'\'\"><i class=\"fa fa-fw fa-ban\"></i>Cancelar envío</a></li></ul></span></div><span>Detalles de envío</span></h1><table class=\"table\"><tbody><tr><th>ID</th><td>{{ ::vm.delivery.id }}</td></tr><tr><th>Fecha y hora de creación</th><td>{{ ::vm.delivery.created_at | amDateFormat:\'DD/MM/YY HH:mm:ss\' }}</td></tr><tr><th>Estado</th><td><hb-delivery-status-label status=\"vm.delivery.delivery_status_id\"></hb-delivery-status-label></td></tr><tr><th>Tipo</th><td>{{ ::vm.delivery.type.name }}</td></tr><tr><th>Compañía</th><td>{{ ::vm.delivery.company.name }}</td></tr><tr><th>Siniestro</th><td>{{ ::vm.delivery.claim_number }}</td></tr><tr><th>Póliza</th><td>{{ ::vm.delivery.policy_number }}</td></tr></tbody></table><uib-tabset><uib-tab index=\"0\" heading=\"Intentos\"><h3>Intentos</h3><table class=\"table\" ng-if=\"vm.delivery.attempts.length\"><thead><tr><th>Fecha y hora</th><th>Canal</th><th>Resultado</th></tr></thead><tbody><tr ng-repeat=\"attempt in vm.delivery.attempts\"><td>{{ ::attempt.created_at | amDateFormat:\'DD/MM/YY HH:mm:ss\' }}</td><td>{{ ::attempt.channel.type.name }}</td><td><span class=\"hb-attempt-error label {{ vm.getErrorReasonLabelClass(attempt) }}\" ng-if=\"vm.shouldDisplayErrorReason(attempt)\" uib-popover=\"{{ ::attempt.error_reason }}\" popover-trigger=\"mouseenter\"><i class=\"fa fa-fw fa-warning\"></i>{{ ::attempt.result.name }}</span> <span class=\"label label-success\" ng-if=\"! vm.shouldDisplayErrorReason(attempt)\"><i class=\"fa fa-fw fa-check\"></i>{{ ::attempt.result.name }}</span></td></tr></tbody></table><div class=\"alert alert-info\" ng-if=\"!vm.delivery.attempts.length\"><p><i class=\"fa fa-fw fa-info-circle\"></i>Este envío aún no se ha intentado entregar.</p></div></uib-tab><uib-tab index=\"1\" heading=\"Metadatos y configuración\"><h3>Metadatos</h3><div hljs=\"\" language=\"json\" source=\"vm.getMetadataAsString()\"></div><h3>Ajustes de configuración</h3><div ng-if=\"vm.delivery.setting_overrides\" hljs=\"\" language=\"json\" source=\"vm.getSettingOverridesAsString()\"></div><div class=\"alert alert-info\" ng-if=\"vm.delivery.setting_overrides === null\"><p><i class=\"fa fa-fw fa-info-circle\"></i>No se ha proporcionado configuración específica para este envío.</p></div></uib-tab><uib-tab index=\"2\" heading=\"Adjuntos\"><h3>Adjuntos</h3><table class=\"table\" ng-if=\"vm.delivery.attachments.length\"><thead><tr><th>Fichero</th><th>Tamaño</th></tr></thead><tbody><tr ng-repeat=\"attachment in vm.delivery.attachments\"><td><i class=\"fa fa-fw fa-file-o\"></i><a href=\"{{ ::attachment.url }}\" target=\"_blank\">{{ ::attachment.filename }}</a></td><td>{{ ::attachment.size | hbBytes }}</td></tr></tbody></table><div class=\"alert alert-info\" ng-if=\"!vm.delivery.attachments.length\"><p><i class=\"fa fa-fw fa-info-circle\"></i>Este envío no tiene ningún adjunto.</p></div></uib-tab></uib-tabset><script type=\"text/ng-template\" id=\"app/deliveries/repeat-delivery-confirmation-modal.html\"><div class=\"modal-header\"> <h3 class=\"modal-title\">¿Repetir envío?</h3> </div> <div class=\"modal-body\"> <p>Parece que este envío ya ha sido entregado con éxito. ¿Desea repetirlo en cualquier caso?</p> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\">Cancelar</button> <button class=\"btn btn-primary\" type=\"button\" ng-click=\"ok()\">Sí, repetir envío</button> </div></script>");
$templateCache.put("app/main/main.html","<div class=\"container main-layout\"><nav class=\"navbar navbar-default\"><div class=\"container-fluid\"><div class=\"navbar-header\"><button type=\"button\" class=\"navbar-toggle collapsed\" data-toggle=\"collapse\" data-target=\"#navbar\"><span class=\"sr-only\">Toggle navigation</span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button> <a class=\"navbar-brand\" href=\"#\"><img class=\"pull-left\" src=\"assets/images/logo.png\" alt=\"The Hub\"> <span>The Hub</span></a></div><div class=\"collapse navbar-collapse\" id=\"navbar\"><ul class=\"nav navbar-nav navbar-right\"><li uib-dropdown=\"\"><a href=\"#\" uib-dropdown-toggle=\"\"><i class=\"fa fa-fw fa-user\"></i>{{ vm.hbSession.user().username }} <b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a href=\"#\" ng-click=\"vm.logout()\"><i class=\"fa fa-fw fa-sign-out\"></i>Cerrar sesión</a></li></ul></li></ul></div></div></nav><div class=\"row\"><div class=\"col-md-3\"><ca-menu header=\"Menú principal\"></ca-menu><ca-menu header=\"Administración\" category=\"admin\"></ca-menu></div><div class=\"col-md-9\"><div class=\"panel panel-default\" style=\"position: relative;\"><ca-loading-overlay></ca-loading-overlay><div class=\"panel-body\" ui-view=\"\"></div></div></div></div></div>");
$templateCache.put("app/user-settings/user-settings.html","<h1 class=\"page-header\">Configuración</h1><form class=\"form-horizontal\" name=\"userSettingsForm\" ng-submit=\"vm.saveSettings()\"><h3>URL de callback</h3><p>Si está definida, el Hub realizará peticiones a esta URL cada vez que ocurra un suceso relevante en relación a un envío.</p><div class=\"form-group\"><label for=\"\" class=\"col-md-3 control-label\">URL de callback</label><div class=\"col-md-5\"><input type=\"text\" class=\"form-control\" placeholder=\"Escriba una URL...\" ng-model=\"vm.settings.callback_url\"></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-5\"><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"vm.ui.savingSettings || userSettingsForm.$invalid\"><span ng-if=\"vm.ui.savingSettings\"><i class=\"fa fa-fw fa-circle-o-notch fa-spin\"></i>Guardando...</span> <span ng-if=\"! vm.ui.savingSettings\">Guardar configuración</span></button></div></div></form>");
$templateCache.put("app/components/channel-status-icon/channel-status-icon.html","<span><i class=\"fa fa-fw fa-circle text-{{ ::vm.getTextClass() }}\" uib-tooltip=\"{{ ::vm.getStatusName() }}\"></i></span>");
$templateCache.put("app/components/delivery-status-label/delivery-status-label.html","<span class=\"label label-{{ vm.getLabelClass() }}\">{{ vm.getStatusName() }}</span>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top navbar-inverse\"><div class=\"container-fluid\"><div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"https://github.com/Swiip/generator-gulp-angular\"><span class=\"glyphicon glyphicon-home\"></span> Gulp Angular</a></div><div class=\"collapse navbar-collapse\" id=\"bs-example-navbar-collapse-6\"><ul class=\"nav navbar-nav\"><li class=\"active\"><a ng-href=\"#\">Home</a></li><li><a ng-href=\"#\">About</a></li><li><a ng-href=\"#\">Contact</a></li></ul><ul class=\"nav navbar-nav navbar-right acme-navbar-text\"><li>Application was created {{ vm.relativeDate }}.</li></ul></div></div></nav>");}]);